import { render, staticRenderFns } from "./HandBooksCard.vue?vue&type=template&id=3ee464bf&scoped=true&"
import script from "./HandBooksCard.vue?vue&type=script&lang=js&"
export * from "./HandBooksCard.vue?vue&type=script&lang=js&"
import style0 from "./HandBooksCard.vue?vue&type=style&index=0&id=3ee464bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee464bf",
  null
  
)

export default component.exports